module.exports = __webpack_public_path__ + "media/newstyle/images/icon-mini-book-orange-2ff0118d78730a196381d2df8683ffa7.svg";